"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var PostAcceptRedirect_1 = require("@CommonFrontendBackend/Accept/PostAcceptRedirect");
var FeatureFlag_1 = __importDefault(require("@CommonFrontendBackend/FeatureFlag"));
var lodash_1 = require("lodash");
var MountReactComponent_1 = __importDefault(require("MountReactComponent/MountReactComponent"));
var InlinePreviewAccept_1 = require("./InlinePreviewAccept");
var SecuredByQwilr_1 = require("AcceptFlow/Utils/SecuredByQwilr");
var PreviewAccept = (function () {
    function PreviewAccept(overlayStack, createUi, make, $timeout, account, block, project, QwilrStripe, primaryDomain, invoke, $http, apiBaseUrl, accepters, usingFeature, closeInlineForm) {
        var projectCreatorProfile = {
            secret: project.links[0].secret,
            branding: account.plan.branding,
        };
        var badgeClickUrl = "//".concat(primaryDomain, "/welcome/start-creating");
        var mockSend = function () { return $timeout(function () { }, 2000); };
        var usingInlineForm = !usingFeature(FeatureFlag_1.default.OptOutNewEditor);
        this.preview = function () {
            var acceptFlow = make(require("AcceptFlow/AcceptFlow"), {
                branding: account.plan.branding,
                sendAcceptRequest: function (acceptData) {
                    acceptData.visitToken = "mocktoken";
                    acceptData.sessionStartedAt = Math.round(Date.now() / 1000);
                    return $http
                        .post("".concat(apiBaseUrl, "/projects/").concat(project._id, "/preview-accept"), acceptData)
                        .then(function (result) {
                        project.previewAcceptanceData = result.data.previewAcceptanceData;
                        project.partialPreviewAcceptanceData = result.data.partialPreviewAcceptanceData;
                    });
                },
                sendPaymentRequest: mockSend,
                accepters: accepters,
                settings: block.settings,
                isPreviewMode: true,
                projectId: project._id,
                closeCurrent: function () {
                    return overlayStack.closeCurrent();
                },
                closeAll: function () {
                    if (usingInlineForm) {
                        closeInlineForm();
                    }
                    else if (block.$isSavedBlock) {
                        while (overlayStack.getStackLength() > 1) {
                            overlayStack.closeCurrent();
                        }
                    }
                    else {
                        overlayStack.closeAll();
                    }
                },
                secretHash: project.links[0].secret,
                stripePublicKey: QwilrStripe,
                projectCreatorProfile: projectCreatorProfile,
                badgeClickUrl: badgeClickUrl,
                getPoweredByQwilr: usingInlineForm
                    ? (0, SecuredByQwilr_1.mountAcceptFlowSecuredByQwilrBtn)((0, MountReactComponent_1.default)(createUi))
                    : invoke(require("CommonUI/PoweredByQwilr/PoweredByQwilr"), null, {
                        projectCreatorProfile: projectCreatorProfile,
                        badgeClickUrl: badgeClickUrl,
                    }),
                isTotalVisible: null,
                isStripeIntegrationEnabled: account.integrations.stripe.enabled || false,
                onPostAcceptance: function () {
                    window.location.href = (0, PostAcceptRedirect_1.getFinalRedirectURL)(block.settings.postAcceptance.url, {
                        pageId: project._id,
                        preview: true,
                    });
                },
                onShowExperienceSurvey: lodash_1.noop,
                getAuditTrailPdfUrl: function () { return Promise.resolve(""); },
            });
            if (usingInlineForm) {
                return createUi(require("./InlinePreviewAccept.html"), {
                    form: acceptFlow.ui,
                    banner: (0, InlinePreviewAccept_1.mountPreviewAcceptBanner)((0, MountReactComponent_1.default)(createUi)),
                    resetButton: (0, InlinePreviewAccept_1.mountResetPreviewAcceptButton)((0, MountReactComponent_1.default)(createUi), { onClick: closeInlineForm }),
                });
            }
            var ui = createUi(require("./PreviewAccept.html"), { inner: acceptFlow.ui });
            return overlayStack.add({
                contentUi: ui,
                options: {
                    hideCloseButton: true,
                    centerContent: false,
                    fullPage: true,
                },
            });
        };
    }
    return PreviewAccept;
}());
exports.default = PreviewAccept;
